import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import DivisionsList from '../components/DivisionsList'

export default function ManageDivisions() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Divisions</h1>
        <Link to="/new-division"><button className="memberAddButton">Add New</button></Link>
      </div>
        <DivisionsList />
    </div>
  )
}
